import React from 'react';
import PropTypes from 'prop-types';
import Drawer from 'material-ui/Drawer';
import { spacing, typography } from 'material-ui/styles';
import MenuItem from 'material-ui/MenuItem';
import { Link } from 'react-router';
import styled from 'styled-components';

import { primary1Color, primary1TextColor, drawerTextColor } from '../theme';
import { SITE_TITLE } from '../config';
import logoImg from '../assets/images/logo.png';
/*
  Styled components
 */
const Title = styled.div`
  cursor: pointer;
  font-size: 16px;
  color: ${primary1TextColor};
  line-height: ${spacing.desktopKeylineIncrement}px;
  font-weight: ${typography.fontWeightLight};
  background-color: ${primary1Color};
  height: 56px;
  text-align: center;
`;

const LogoContainer = styled.div`
  height: 120px;
  background-color: white;
  text-align: center;
  padding-top: 20px;
`;

const Logo = styled.img`
  width: 180px;
`;

const MenuItemStyled = styled(MenuItem)`
  color: ${drawerTextColor}px !important;
  font-size: 14px !important;
`;

const propTypes = {
  navDrawerOpen: PropTypes.bool,
  menus: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.any.isRequired,
      icon: PropTypes.any,
      link: PropTypes.string.isRequired,
    })
  ),
};

const defaultProps = {
  navDrawerOpen: false,
};

const LeftDrawer = (props) => {
  const { navDrawerOpen } = props;

  return (
    <Drawer docked containerStyle={{ backgroundColor: 'white' }} open={navDrawerOpen}>
      <Title>{SITE_TITLE}</Title>
      <LogoContainer>
        <Logo src={`${logoImg}`} />
      </LogoContainer>
      <div>
        {props.menus.map((menu, index) => (
          <MenuItemStyled
            key={index}
            primaryText={menu.text}
            leftIcon={menu.icon}
            containerElement={<Link to={menu.link} />}
          />
        ))}
      </div>
      <p style={{ bottom: 0, position: 'absolute', margin: '0 0 5px 5px' }}>ver. 1.0.2</p>
    </Drawer>
  );
};

LeftDrawer.propTypes = propTypes;
LeftDrawer.defaultProps = defaultProps;

export default LeftDrawer;



// WEBPACK FOOTER //
// ./src/components/LeftDrawer.js